import type { RestoredFromSession } from '../../hooks/useAutoInvestigation';

/** Wording for the restore marker; kept apart from the component so it can be tested without a DOM. */
export function restoredResultsText(restored: RestoredFromSession, locale?: string): string {
    const at = new Date(restored.savedAt);
    const when = Number.isNaN(at.getTime())
        ? 'earlier in this session'
        : at.toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' });
    const parts = [`Restored from this session, run at ${when}.`];
    if (!restored.complete) parts.push('You left while the run was still going, so only the steps that had finished are shown.');
    if (restored.canvasChanged) parts.push('The canvas has changed since this run.');
    parts.push('Re-run to refresh.');
    return parts.join(' ');
}

/** Marker shown above the Analysis results when they were put back from sessionStorage. */
export function RestoredResultsBanner({ restored }: { restored?: RestoredFromSession | null }) {
    if (!restored) return null;
    return (
        <div
            data-testid="restored-results-banner"
            className="mx-3 mt-2 mb-1 px-2 py-1.5 rounded-lg border border-sky-500/30 bg-sky-500/10 text-[11px] text-muted-foreground leading-snug"
        >
            {restoredResultsText(restored)}
        </div>
    );
}
